import { createDocumentPDFGenerator } from './documentReportBase';

export const generateBillingNotePDF = createDocumentPDFGenerator('ใบวางบิล/ใบแจ้งหนี้', '#7C3AED');
